import axios from './mayiRequest'
/**
 * 查询城市是否支持筛选
 * @param {Object} params 查询参数
 * @param {Number} params.cityId 城市ID
 * @param {String} params.cds 筛选项id
 */
export function searchfilteritem(params) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/filter/searchfilteritem', {
    ...params
  })
}
